import { Link } from "react-router-dom";

export default function WhatIsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full mb-4">
            Getting Started
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            What Is BaseTao Spreadsheet?
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Understanding the fundamentals of BaseTao Spreadsheet and how it transforms your shopping research workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
              <i className="ri-file-list-3-line text-lg text-primary-600"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
              What It Is
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              BaseTao Spreadsheet is a powerful research and organization system that helps shoppers systematically track products, compare prices across categories, and manage their entire purchasing workflow in one unified tool. Whether you are browsing shoes, clothing, or accessories, the spreadsheet approach gives you clarity and control.
            </p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
            <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
              <i className="ri-search-line text-lg text-accent-600"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
              Why Users Search For It
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Shoppers worldwide search for BaseTao Spreadsheet because it solves the common problem of scattered product research. Instead of juggling multiple browser tabs, notes, and price comparisons manually, the spreadsheet method centralizes everything, saving hours of research time and helping buyers make confident, data-driven decisions.
            </p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
            <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
              <i className="ri-lightbulb-line text-lg text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
              How It Improves Decisions
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              By organizing product data with structured columns for price, shipping estimates, quality notes, and category tags, BaseTao Spreadsheet transforms guesswork into systematic analysis. Our research shows that organized spreadsheet users save an average of 15-25% on total order costs through better comparison and strategic purchasing.
            </p>
          </div>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            Read the full guide
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}